import React from 'react';
import './main.css'

import Card from '../../images/Payment Convenies/card.png';
import List from '../../images/Payment Convenies/list.png';

export default function PaymentConvenient() {
    return (
        <>
            <div className="payment-convenies">
                <h1 className="title">Оплата удобным для вас способом</h1>
                <div className="theme-payment-conven"></div>
                <div className="payment-group">
                    <div className="payment-group-left">
                        <div className="list-group">
                            <div className="paragraph">
                                <h1>Наличный и безналичный расчёт</h1>
                                <p>Оплата наличными
                                    и картами Visa, MasterCard</p>
                            </div>
                            <div className="image">
                                <img src={Card} alt="error" />
                                <div className="deco"></div>
                            </div>
                        </div>
                    </div>
                    <div className="payment-group-right">
                        <div className="list-group">
                            <div className="paragraph">
                                <h1>Оплата 50%</h1>
                                <p>
                                    Возможность 50% оплаты при заключении договора и 50% по факту установки
                                </p>
                            </div>
                            <div className="image">
                                <img src={List} alt="error" />
                                <div className="deco"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="Installment">
                    <div className="elements">
                        <h1>Рассрочка от 6 до 12 месяцев</h1>
                        <p>
                            Рассрочка без первоначального взноса и переплат.
                            Срок рассмотрение заявки от 2 до 30 минут. 
                        </p>
                        <button>Подать заявку</button>
                    </div>
                    <div className="months">
                        <div className="month time">
                            <h1>12</h1>
                            <p>месяцев</p>
                        </div>
                        <div className="day time">
                            <h1>6</h1>
                            <p>месяцев</p>
                        </div>
                        <div className="overpayment time">
                            <h1>0<span>%</span></h1>
                            <p>без переплат</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
